import script from "./Artists.vue?vue&type=script&setup=true&lang=js"
export * from "./Artists.vue?vue&type=script&setup=true&lang=js"

import "./Artists.vue?vue&type=style&index=0&id=46272632&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\artware\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46272632"]])

export default __exports__